import React, { createContext, useState, useContext, useCallback } from "react";
import Alert from "../components/alertv2";

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState(null);

  const showAlert = useCallback((message, type = "info") => {
    setAlert({ message, type });

    // Error messages (the red alert) get an extra second — they tend to be longer/more
    // important text (e.g. "no available package") that needs more time to read than a
    // quick success/info confirmation.
    setTimeout(() => setAlert(null), type === "error" ? 2000 : 1000);
  }, []);

  const closeAlert = useCallback(() => {
    setAlert(null);
  }, []);

  return (
    <AlertContext.Provider value={{ showAlert, closeAlert }}>
      {children}
      {alert && (
        <Alert
          message={alert.message}
          type={alert.type}
          closeAlert={alert.type === "info" ? closeAlert : null} // Pass closeAlert only for "info" type
        />
      )}
    </AlertContext.Provider>
  );
};

export const useAlert = () => useContext(AlertContext);
